import { useContext } from "react";
import { ColorContext } from "../Contexts";
import { LoyaltyChallenge, LoyaltyChallengeStatus, LoyaltyChallengeSubmissionMin, LoyaltyChallengeType } from "../../../pages/api/loyalty/challenges";
import { AccessTime, DoNotDisturb, Done } from '@mui/icons-material';
import loyaltyStyles from '../../../styles/Loyalty.module.css';
import Image from "next/image";

export function SubmissionStatusIcon({ status }: { status: LoyaltyChallengeStatus }) {
    const color = useContext(ColorContext);
    if (status === LoyaltyChallengeStatus.DENIED) {
        return <DoNotDisturb fontSize='inherit' htmlColor='#EB3843' />
    }
    if (status === LoyaltyChallengeStatus.PENDING) {
        return <AccessTime fontSize='inherit' htmlColor='#636674' />
    }
    return <Done fontSize='inherit' htmlColor={color} />;
}

export default function ChallengeDetail({ challenge }: { challenge: LoyaltyChallenge }) {
    const color = useContext(ColorContext);
    function renderLinks() {
        return challenge.data?.links?.map((link, i) =>
            <a key={i} className={loyaltyStyles.button} style={{ marginBottom: 8, color, background: "#f4f4f4" }} href={link.url} target="_blank" rel="noreferrer">{link.text}</a>
        );
    }

    function renderSubmission(submission: LoyaltyChallengeSubmissionMin) {
        if (!submission.data) return;
        const left = 'imageUrl' in submission.data ?
            <Image width={50} height={50} src={submission.data.imageUrl} alt={''} style={{ objectFit: 'contain' }} />
            : <div style={{ fontSize: 14 }}>{submission.data.submission}</div>;

        return <div className={loyaltyStyles.action} key={submission.id}>
            {left}
            <div className={loyaltyStyles.rewardRight}>
                <SubmissionStatusIcon status={submission.status} />
            </div>
        </div>;
    }

    return <>
        <div style={{ margin: "12px 0", color: 'black', textAlign: 'center' }}>
            {challenge.title}
            {challenge.description && <p>{challenge.description}</p>}
        </div>
        {renderLinks()}
        {
            challenge.submissions.length > 0 &&
            (challenge.type === LoyaltyChallengeType.PHOTO
                || challenge.type === LoyaltyChallengeType.TEXT) &&
            <div style={{ marginBottom: 4, fontSize: 14 }}>
                You&apos;ve submitted:
                {challenge.submissions.map(renderSubmission)}
            </div>
        }
    </>
}